import { BundleResourcesPackage } from "resource-system";
export class LevelsResourcesPackage extends BundleResourcesPackage {
    public constructor() {
        super("LevelsResourcesPackage");
    }
    public get assets_levels_level_1_json(): Object {
        return this.resource<Object>("assets/levels/level_1.json");
    }
    public get assets_levels_level_2_json(): Object {
        return this.resource<Object>("assets/levels/level_2.json");
    }
    public get assets_levels_level_3_json(): Object {
        return this.resource<Object>("assets/levels/level_3.json");
    }
}

